export class EnderecoCep {

    nmTpEndereco: string;
    nmEndereco: string;
    nmBairro: string;
    nmCidade: string;
    nmUF: string;
    nuCep: string;
    nuComplementoCep: string;

    constructor() {}
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/enderecoCep.ts